import React from 'react';
import { Loader } from '@/components/custom/loader';
import { EmptyState } from '@/components/custom/empty-state';

export function SectionState({ loading, error, onRetry, errorTitle = 'Não foi possível carregar esses dados', children }) {
  if (loading) {
    return <Loader />;
  }

  if (error) {
    return (
      <EmptyState
        type="data"
        variant="plain"
        title={errorTitle}
        text="Tente novamente em instantes."
        cta={{ text: 'Tentar novamente', onClick: onRetry }}
      />
    );
  }

  return children;
}
